import * as React from 'react';
import { DataSource } from '../../../shared/DataSource';
import { BtnSelect, IBtnSelectOptGroup, IBtnSelectOption, IBtnSelectProps } from '../BtnSelect';
import { IMultiNode } from '../DataMultiBtnSelect';

interface IDataBtnSelectProps extends IBtnSelectProps {
  source: DataSource<IMultiNode, any>
  groupMode?: boolean
  onClear?: () => void
}

interface IDataBtnSelectState {
  options?: IBtnSelectOption[]
  groupOptions?: IBtnSelectOptGroup[]
  hasLoaded: boolean
}

export class DataBtnSelect extends React.Component<IDataBtnSelectProps, IDataBtnSelectState> {
  state: IDataBtnSelectState = {
    hasLoaded: false,
  }

  hasMount = false
  removeOnSyncListener: () => void = () => ({})

  componentWillMount() {
    this.removeOnSyncListener = this.props.source.onSync(({ records: data }) => {
      const hasLoaded = true
      let options;
      let groupOptions;

      if (this.props.groupMode) {
        groupOptions = data
      } else {
        options = data
      }

      this.setState({ options, groupOptions, hasLoaded })
    })

    this.props.source.sync()
  }

  componentDidMount() {
    this.hasMount = true
  }

  componentWillUnmount() {
    this.removeOnSyncListener()
  }

  onChange(newValue: string, newLabel: string) {
    const { onChange = () => ({}) } = this.props

    onChange(newValue, newLabel)

    if (this.hasMount && this.state.hasLoaded) {
      this.props.source.syncDependencies()
    }
  }

  render() {
    const { hasLoaded } = this.state
    const { showSpinner = !hasLoaded } = this.props

    return <BtnSelect
      showSpinner={showSpinner}
      disabled={this.props.disabled || !hasLoaded}
      clearable={this.props.clearable}
      defaultValue={this.props.defaultValue}
      value={this.props.value}
      onChange={(newValue, newLabel) => this.onChange(newValue, newLabel)}
      header={this.props.header}
      useMobileMode={this.props.useMobileMode}
      persistLabel={this.props.persistLabel}
      options={this.state.options}
      groupOptions={this.state.groupOptions}
      onClear={this.props.onClear}
      clearLabel={this.props.clearLabel}
    />
  }
}
